// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Jisw","inner":"Footer_inner__3SvM4"};